<div class="flex flex-col w-full h-full p-6 gap-6 bg-white overflow-auto">

  <create-ta-timeline></create-ta-timeline>

  <div class="flex w-full gap-6 items-start px-7">
    <div class="flex flex-col gap-4">
      <div class="flex items-center gap-4">
        <div class="justify-start text-surface-900 text-2xl font-semibold font-['Inter'] leading-8">
          Review and Submit your TA
        </div>
        <p-chip label="In Progress"/>
      </div>
      <ta-audit-log-button [taSubmission]="store.taSubmission()"></ta-audit-log-button>

      <ta-toast
        [visible]="!!withholdApproval()"
        title="Travel Allowance Approval Withheld"
        severity="warn"
        [closable]="false"
        size="regular"
      >
        <div class="flex flex-col">
          <span>{{ 'Date: ' + ((withheldData()?.date | date:'dd/MM/yy') ?? '-') }}</span>
          <span>{{ 'Withheld by: ' +   (withheldData()?.approverName ?? '-')}}</span>
          @if (withheldData()?.approverNotes) {
            <span class="flex-wrap">{{'Notes: ' + (withheldData()?.approverNotes ?? '-')}}</span>
          }
        </div>
      </ta-toast>
    </div>
    <div class="flex-1"></div>
    @if (!isFlightOnly()) {
      <div class="flex flex-col gap-2 items-end">
        <ta-cost-bubble title="Total TA Value" [value]="estimatedTaValue()" severity="outlined"></ta-cost-bubble>
        <div class="w-full h-[1px] bg-surface-200"></div>
        @if (isPrePaid()) {
          <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
        }
        <ta-cost-bubble title="Day Trip Component" [value]="dayTripComponent()" severity="purple"></ta-cost-bubble>
      </div>
    }
  </div>

  <view-ta [edit]="true" (dialogClosed)="updateEstimate()"></view-ta>

  <p-card>
    <div class="flex flex-col gap-2">
      <div class="text-surface-900 text-xl font-semibold font-['Inter'] leading-6">Submit TA</div>
      <div class="text-surface-500 text-xs font-normal font-['Inter'] leading-5 pt-2">Use this space to enter any comments that will clarify your travel plans and assist those reviewing and approving the trip.</div>
      <textarea pTextarea
                [(ngModel)]="taNotes"
                data-testid="review-ta-notes"
                placeholder="Provide more details..."
                rows="5"
                pSize="small"
                [autoResize]="true"
                [disabled]="!canSubmit()"
                class="lg:w-1/2 w-full"></textarea>

      <!-- The Account Blocked warning lives in bread-crumb-bar, which this route opts into via
           showAccountBlocked (app.routes.ts) - a second copy here just said the same thing twice. -->

      @if (showZeroValueWarning()) {
        <div class="lg:w-1/2 w-full pt-2">
          <ta-toast
            title="This TA is estimated at $0.00"
            severity="warn"
            [closable]="false"
            size="max"
          >
            <div class="flex flex-col gap-1">
              <span>Your travel covers more than one day but no allowance has been estimated.</span>
              <span>This usually means a catering option is still to be chosen on the itinerary.</span>
            </div>
          </ta-toast>
        </div>
      }

      @if (showNoFlightDocumentsWarning()) {
        <div class="lg:w-1/2 w-full pt-2">
          <ta-toast
            data-testid="review-no-flight-documents-warning"
            title="No flight booking documents attached"
            severity="error"
            [closable]="false"
            size="max"
          >
            <div class="flex flex-col gap-1">
              <span>Upload the relevant CTM documents.</span>
            </div>
          </ta-toast>
        </div>
      }

      @if (showMissingDocumentsWarning()) {
        <div class="lg:w-1/2 w-full pt-2">
          <ta-toast
            data-testid="review-missing-documents-warning"
            title="Required documentation is missing"
            severity="error"
            [closable]="false"
            size="max"
          >
            <div class="flex flex-col gap-1">
              <span>This TA includes air travel, a hire car or city motel accommodation, so CTM booking documents are required.</span>
            </div>
          </ta-toast>
        </div>
      }

      @if (taSubmissionDatasource.hasOnlyCasualTravellers()) {
        <div class="lg:w-1/2 w-full pt-2">
          <ta-toast
            data-testid="review-all-casual-warning"
            title="A TA needs at least one staff traveller"
            severity="warn"
            [closable]="false"
            size="max"
          >
            <div class="flex flex-col gap-1">
              <span>Casual travellers can't be the only travellers except for booking officer TAs.</span>
              <span>Add a staff traveller before submitting.</span>
            </div>
          </ta-toast>
        </div>
      }

      <div class="flex gap-2 pt-4 items-center">
        <!-- Blocked while a save is queued: submitting is no longer queued behind the field and
             itinerary saves, so it must not start until they have landed. -->
        <p-button (onClick)="submitTaFinal()"
                  [disabled]="!canSubmit() || submitting() || store.isSavingData()"
                  [loading]="submitting() || store.isSavingData()"
                  [pTooltip]="cantSubmitMessage()"
                  styleClass="w-64">
          <i class="pi pi-send pl-[1px]"></i>
          <span class="flex-1">Submit TA for Approval</span>
        </p-button>
        <!-- Once approvals exist (e.g. withheld) the TA has history, so it can only be cancelled. -->
        @if (hasApprovalHistory()) {
          @if (canCancel()) {
            <p-button [severity]="'danger'" styleClass="w-64" (onClick)="cancelSubmissionClicked()">
              <i class="pi pi-trash pl-[1px]"></i>
              <span class="flex-1">Cancel TA Application</span>
            </p-button>
          }
        } @else {
          <p-button [severity]="'danger'" styleClass="w-64" (onClick)="deleteSubmissionClicked()">
            <i class="pi pi-trash pl-[1px]"></i>
            <span class="flex-1">Delete TA Application</span>
          </p-button>
        }
      </div>
    </div>
  </p-card>
</div>
